export const TOA_OPTIONS = [
    {label:'Default Production API', value: 1},
    {label:'Visa Debit Card 2- (Cardinal)', value: 2},
    {label:'Visa Debit Card 4, Visa Prepaid card, Visa Debit Card Landmark, Visa Prepaid Debit Card', value: 3},
    {label:'Visa Debit Card', value: 4},
    {label:'Peak Visa Debit', value: 5},
    {label:'Visa Debit Card (Related Group)', value: 6},
    {label:'Sandbox API', value: 7},
]

export const PROGRAM_TYPES = [
    {label:'Default',value:'default'},
    {label:'Employee',value:'employee'},
    {label:'Resident',value:'resident'},
    {label:'Shell',value:'shell'}
]

export const PROGRAM_STATUSES = [
    {label:'Active',value:'active'},
    {label:'Deleted',value:'deleted'},
    {label:'Locked',value:'locked'}
]